import script from "./HeaderTabs.vue?vue&type=script&setup=true&lang=js"
export * from "./HeaderTabs.vue?vue&type=script&setup=true&lang=js"

import "./HeaderTabs.vue?vue&type=style&index=0&id=76c19fc0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-76c19fc0"]])

export default __exports__